class SearchContentToggle extends window.BAO.CustomElement() {
  static get requiredExternalElements () {
    return ['searchDropdown', 'searchScroller']
  }

  setupListeners () {
    super.setupListeners()

    this.onTabClick = this.onTabClick.bind(this)
    this.onSearchOpen = this.onSearchOpen.bind(this)
    this.onSearchClose = this.onSearchClose.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.checkOverflow = this.checkOverflow.bind(this)

    if (this.els.tab?.exists) {
      for (const tab of this.els.tab.elements) {
        this.listeners.add(tab, 'click', this.onTabClick)
      }
    }

    if (this.externalEls.searchDropdownTrigger?.exists) {
      for (const button of this.externalEls.searchDropdownTrigger.elements) {
        this.listeners.add(button, 'click', this.onSearchOpen)
      }
    }

    if (this.els.close?.exists) {
      const close = this.els.close.elements[0]
      this.listeners.add(close, 'click', this.onSearchClose)
    }

    if (this.externalEls.close?.exists) {
      for (const close of this.externalEls.close.elements) {
        this.listeners.add(close, 'click', this.onSearchClose)
      }
    }

    if (this.externalEls.menuOpenCloseSearch?.exists) {
      for (const close of this.externalEls.menuOpenCloseSearch.elements) {
        this.listeners.add(close, 'click', this.onSearchClose)
      }
    }

    this.listeners.add(document, 'click', this.handleClickOutside)
    this.listeners.add(window, 'resize', this.checkOverflow)

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.SEARCH_TAB.SEARCH_RESULTS_LOADED,
      this.checkOverflow,
    )
  }

  checkOverflow () {
    const dropdown = this.externalEls.searchScroller.element
    const isOverflowing = dropdown.scrollHeight > dropdown.clientHeight

    dropdown.classList.toggle('is-overflowing', isOverflowing)
  }

  handleClickOutside (event) {
    const searchDropdown = this.externalEls.searchDropdown.element
    const isClickInside = searchDropdown.contains(event.target)
    const isSearchTrigger = this.externalEls.searchDropdownTrigger.elements.some(
      trigger => trigger.contains(event.target),
    )

    if (!isClickInside && !isSearchTrigger && searchDropdown.classList.contains('hd-Dropdown-active')) {
      event.preventDefault()
      this.onSearchClose()
    }
  }

  onTabClick (event) {
    const tabContent = event.target.getAttribute('data-trigger-for')

    const content = this.querySelector(`[data-target-for="${tabContent}"]`)

    for (const tab of this.els.tab.elements) {
      if (tab === event.target) {
        tab.classList.add('hd-SearchDropdown_NavigationLink-active')
      } else {
        tab.classList.remove('hd-SearchDropdown_NavigationLink-active')
      }
    }

    for (const contentElement of this.els.content.elements) {
      if (contentElement === content) {
        contentElement.setAttribute('aria-hidden', 'false')
      } else {
        contentElement.setAttribute('aria-hidden', 'true')
      }
    }

    window.BAO.dispatchEvent(window.BAO.EVENTS.SEARCH_TAB.SWAPPED)
    this.checkOverflow()
  }

  onSearchOpen () {
    document.documentElement.classList.add('util-SiteOverflowed')
    this.externalEls.searchDropdown.element.classList.add('hd-Dropdown-active')
    this.externalEls.searchDropdownTrigger.element.setAttribute('aria-hidden', 'true')
    this.externalEls.menuOpenCloseSearch.element.setAttribute('aria-hidden', 'false')

    setTimeout(() => {
      this.externalEls.input.element.focus()
      this.checkOverflow()
    }, 700)
  }

  onSearchClose () {
    document.documentElement.classList.remove('util-SiteOverflowed')
    this.externalEls.input.element.blur()
    this.externalEls.searchDropdown.element.classList.remove('hd-Dropdown-active')
    this.externalEls.searchDropdownTrigger.element.setAttribute('aria-hidden', 'false')
    this.externalEls.menuOpenCloseSearch.element.setAttribute('aria-hidden', 'true')
  }
}
if (!customElements.get('search-content-toggle')) {
  customElements.define('search-content-toggle', SearchContentToggle)
}
